import React from 'react';
import { useTranslation } from 'react-i18next';
import PhoneIcon from '../../../../public/static/images/item/round-phone.svg';
import Icon from '../../../Icon';
import useScreenSize from '../../../../hooks/useScreenSize';
import { StickyPhoneButton } from '../../../BottomPhoneButton/StickyPhoneButton';

interface PhoneButtonProps {
  stat?: string;
  isIconButton: boolean;
  phones: string[] | null;
  onClickHandler: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
}

export const PhoneButton: React.FC<PhoneButtonProps> = ({
  isIconButton,
  stat,
  phones,
  onClickHandler
}) => {
  const { t } = useTranslation();
  const { isSmallOrLargeDesktop } = useScreenSize();

  const isOnePhone = phones?.length === 1;

  if (isIconButton) {
    return (
      <i
        role="button"
        tabIndex={-1}
        onKeyPress={onClickHandler}
        onClick={onClickHandler}
        data-stat={stat}
        aria-label={t('common.call')}
      >
        <Icon width={50} height={50} IconComponent={PhoneIcon} indent={false} />
      </i>
    );
  }

  if (!isSmallOrLargeDesktop) {
    return (
      <StickyPhoneButton
        isOnePhone={isOnePhone}
        stat={stat}
        phones={phones}
        isButtonSticky={!isSmallOrLargeDesktop}
        onClick={onClickHandler}
        isCurrentItemPage
      />
    );
  }

  return null;
};
